export default "__VITE_ASSET__Bef4vNqv__"